'use client';

import type { ReactNode } from 'react';
import { useEffect, useRef, useState } from 'react';
import styles from './reviews-carousel.module.css';

export function ReviewsTrack({ children }: { children: ReactNode }) {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element || typeof IntersectionObserver === 'undefined') return;
    const observer = new IntersectionObserver(([entry]) => setVisible(entry.isIntersecting));
    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      data-visible={visible}
      className={`${styles.viewport} w-full bg-[#F1F6F8] py-12 sm:py-16 lg:py-20`}
    >
      <div className={styles.track}>{children}</div>
    </div>
  );
}
